export default __webpack_public_path__ + "static/media/logo.d68437e8.jpg";